import MapIcon from '@mui/icons-material/Map';
import {
  ArrayField,
  AutocompleteInput,
  Button,
  ChipField,
  CreateButton,
  Datagrid,
  DateField,
  DeleteButton,
  EditButton,
  Filter,
  ImageField,
  List,
  ReferenceInput,
  SelectInput,
  SingleFieldList,
  TextField,
  TextInput,
  TopToolbar,
  usePermissions,
  useRecordContext,
  useRedirect,
} from 'react-admin';
import { Permission, Permissions } from '../../components';
import { CNPJField, PhoneField } from '../../components/Fields';
import { PERMISSIONS } from '../../constants';
import { filterToQuery } from '../../utils';

const StationFilter = () => {
  return (
    <Filter>
      <TextInput label="Pesquisar" source="search" alwaysOn />
      {Permissions({
        permissions: [PERMISSIONS.ADMIN],
        children: (
          <SelectInput
            source="status"
            label="Status"
            isRequired
            choices={[{ id: true, name: 'Ativa' }, { id: false, name: 'Inativa' }]}
            alwaysOn
          />
        )
      })}
      {Permissions({
        permissions: [PERMISSIONS.ADMIN],
        children: (
          <ReferenceInput source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null} alwaysOn>
            <AutocompleteInput
              label="Rede"
              optionText="name"
              filterToQuery={filterToQuery}
              sx={{ minWidth: 220 }}
            />
          </ReferenceInput>
        )
      })}
    </Filter>
  );
}

const NumericIdField = (props) => {
  const record = useRecordContext();
  if (!record) { return null; }

  return record.numericIds?.map((_, ind) => (
    <ChipField source={`numericIds[${ind}]`} />
  ));
};

export const StationList = () => {
  const { permissions } = usePermissions();

  return (
    <Datagrid rowClick="show" bulkActionButtons={false} >
      <ImageField sx={{ '& img': { maxWidth: '4rem' } }} source="imagePath" label="Imagem" />
      <TextField source="name" label="Nome" />
      <ArrayField source="numericIds" label="IDs Numéricos">
        <NumericIdField />
      </ArrayField>
      <CNPJField source="cnpj" label="CNPJ" />
      <PhoneField source="phone" label="Telefone" sortable={false} />
      <DateField source="createdAt" label="Adicionado em" />
      {permissions && [
        PERMISSIONS.UPDATE_STATION,
        PERMISSIONS.REGISTER_STATION_OPENING_HOURS,
        PERMISSIONS.REGISTER_STATION_ADDRESS,
        PERMISSIONS.REGISTER_STATION_FINANCIAL,
        PERMISSIONS.REGISTER_STATION_PAYMENT,
        PERMISSIONS.REGISTER_STATION_GPS,
        PERMISSIONS.REGISTER_STATION_CONCENTRATOR,
        PERMISSIONS.REGISTER_STATION_SYNCHONIZATION,
        PERMISSIONS.REGISTER_STATION_IDENTIFICATION,
      ].some(((permission) => permissions.includes(permission))) && (
          <EditButton />
        )}
    </Datagrid>
  )
};

const ListActions = () => {
  const redirect = useRedirect();
  return (
    <TopToolbar>
      <Permission permission={PERMISSIONS.ADMIN}>
        <CreateButton />
      </Permission>
      <Button
        onClick={() => redirect('/map-stations')}
        label='Mostrar mapa'
      >
        <MapIcon />
      </Button>
    </TopToolbar>
  );
}

export default ({ permissions, ...props }) => {
  return (
    <List
      actions={<ListActions />}
      exporter={false}
      {...props}
      title="Postos"
      sort={{ field: 'name', order: 'ASC' }}
      filter={
        localStorage.getItem('chainId')
          ? { chainId: localStorage.getItem('chainId') }
          : null
      }
      filterDefaultValues={{ status: true }}
      filters={<StationFilter permissions={permissions} />}
    >
      <StationList />
    </List>
  )
};
